// @flow
import { Cancel, Check } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { CONFIRMATION } from "../../../../locales/components/namespaces";

type Props = {
	open: boolean,
	handleDialog: Function
};

const Confirmation = (props: Props) => {
	const {
		open,
		handleDialog,
		title,
		onYes = () => {
		},
		onNo = () => {
		},
		yesBtnText,
		noBtnText,
		hasBtnIcons = true,
		yesAction = true,
		noAction = true,
		maxWidth = 'xs',
		loading = false,
		sx = {},
		otherDialogProps = {}
	} = props
	const { t } = useTranslation(CONFIRMATION)
	const theme = useTheme()
	const color = theme.palette.pageTitle.textColor
	const handleClose = (evt, details) => {
		if (details === 'backdropClick' || details === 'escapeKeyDown') return
		handleDialog(false)
	}
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth={maxWidth}
			sx={sx}
			slotProps={{
				paper: {
					sx: {
						overflowY: 'initial',
						minWidth: '340px'
					}
				}
			}}
			{...otherDialogProps}>
			<DialogTitle component={'h6'} sx={{paddingTop: 1}}>
				<Typography
					variant={'h6'}
					component={'div'}
					color={color}
					mt={1}
					p={0.5}
				>
					{title}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<DialogContentText component={'div'}>
					{props.children}
				</DialogContentText>
			</DialogContent>
			{(yesAction || noAction) && (
				<DialogActions>
					{noAction && (
						<Button
							color="error"
							size={"small"}
							variant={"contained"}
							onClick={onNo}
							startIcon={hasBtnIcons ? <Cancel/> : null}
							sx={{
								marginRight: 'auto'
							}}
							loading={loading}
						>
							{noBtnText ? noBtnText : t('NO')}
						</Button>
					)}
					{yesAction && (
						<Button
							size={"small"}
							variant={"contained"}
							color={'success'}
							onClick={onYes}
							startIcon={hasBtnIcons ? <Check/> : null}
							loading={loading}
						>
							{yesBtnText ? yesBtnText : t('YES')}
						</Button>
					)}
				</DialogActions>
			)}
		</Dialog>
	)
}

export default Confirmation